import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {GET_TOKENS} from "./actionTypes";
import {setTokens} from "./actions";
import {getTokens} from "../../../helpers/tokens";

function* getAllTokens({ payload: { org } }) {
    try {
        const response = yield call(getTokens);
        yield put(setTokens({ tokens: response, error: null })); // Dispatch success action
    } catch (error) {
        console.error("Error fetching tokens:", error);
        yield put(setTokens({ error: error.message })); // Handle errors properly
    }
}

export function* watchgetTokens() {
    yield takeEvery(GET_TOKENS, getAllTokens);
}

function* variablesSaga() {
    yield all([fork(watchgetTokens)]);
}

export default variablesSaga;
